import { Dialog, DialogTitle, DialogContent, Typography, DialogActions, Button, Box } from "@mui/material";
import ErrorIcon from '@mui/icons-material/ErrorOutline'
    ;
const ErrorDialogView = ({ open, onClose }) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle sx={{ mx: -1.5 }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: .5 }}><ErrorIcon sx={{ fontSize: 20 }} /><Typography>Error</Typography></Box>
            </DialogTitle>
            <DialogContent>
                <Typography>Something went wrong!. Please try again.</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ErrorDialogView;